import { useBoolean } from "ahooks";
import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

export default function useHashModal(
  hash: string,
  options: { title?: string; onShow?: () => void; onHide?: () => void } = {}
) {
  const { title, onShow, onHide } = options;
  const history = useHistory();
  const [visible, { setTrue, setFalse }] = useBoolean(false);
  const oldTitleRef = useRef("");

  useEffect(() => {
    if (history.location.hash === hash) {
      setTrue();
      document.body.style.overflow = "hidden";
      if (title) {
        oldTitleRef.current = document.title;
        document.title = title;
      }
      onShow?.();
    } else {
      setFalse();
      document.body.style.overflow = "";
      if (oldTitleRef.current) {
        document.title = oldTitleRef.current;
        oldTitleRef.current = "";
      }
      onHide?.();
    }
  }, [hash, history.location.hash, onHide, onShow, setFalse, setTrue, title]);

  return {
    visible,
  };
}
